import { render, staticRenderFns } from "./Estudantes-finalistas-geral.vue?vue&type=template&id=4ac1a46e&scoped=true&"
import script from "./Estudantes-finalistas-geral.vue?vue&type=script&lang=js&"
export * from "./Estudantes-finalistas-geral.vue?vue&type=script&lang=js&"
import style0 from "./Estudantes-finalistas-geral.vue?vue&type=style&index=0&id=4ac1a46e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac1a46e",
  null
  
)

export default component.exports